import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Dashboard from './components/Dashboard';
import Home from './components/Home';
import SmartNotFound from './components/404';
import LagosWasteMap from './components/map';
function App() {
  return (
<Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path ="/dashboard" element ={<Dashboard></Dashboard> } />
        <Route path='/map' element ={<LagosWasteMap/>}/>
        <Route path='*' element ={<SmartNotFound/>}/>
  </Routes>
  </Router>
  );
}

export default App;
